<template>
  <div>
    <section class="contact">
      <div ref="contentWrap" class="contact__w">
        <aside class="contact__nav">
          <div class="contact__nav-line" />
          <ul ref="navList" class="contact__nav-list">
            <li
              v-for="(item, index) in navigation"
              :key="index"
              class="contact__nav-list-item"
              :class="{ active: index === isActiveNav }"
              :data-section="item.link"
              @click="scrollingTo(index)"
            >
              <a class="contact__nav-list-item">
                <div class="contact__nav-list-count">{{ index + 1 }}</div>
                <p class="contact__nav-list-title">
                  {{ _T(item.title) }}
                </p>
              </a>
            </li>
          </ul>
        </aside>
        <div class="contact__main">
          <h1 class="contact__title">
            {{ _T("@Contacts") }}
          </h1>
          <div ref="sections" class="contact__blocks-wrp">
            <div data-section="generalPhone" class="contact__main-block">
              <div class="contact__block-title-w">
                <h3 class="contact__block-title">
                  <span
                    id="generalPhone"
                    class="ui-anchor"
                    :style="{ '--topScroll': `-${heightHeader}` }"
                  />
                  {{ _T("@General number") }}
                </h3>
                <div class="contact__block-line" />
              </div>
              <div class="contact__block-content">
                <h4 class="contact__block-subtitle">
                  {{ _T("@Multichannel hotline telephone") }}
                </h4>
                <div class="contact__block-content-wrp-tel">
                  <a
                    class="contact__button-transparent ringo-tel"
                    :href="`tel:${_T('@Call center number')}`"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        class="contact__btn-img"
                        d="M18.1183 14.702L14.0001 15.5C11.2184 14.1038 9.50009 12.5 8.50009 10L9.27004 5.8699L7.81461 2L4.06369 2C2.93614 2 2.04823 2.93178 2.21663 4.04668C2.63704 6.83 3.87662 11.8765 7.50009 15.5C11.3053 19.3052 16.7858 20.9564 19.8021 21.6127C20.9669 21.8662 22.0001 20.9575 22.0001 19.7655L22.0001 16.1812L18.1183 14.702Z"
                        stroke="#F36C21"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span>{{ _T("@Call center number") }}</span>
                  </a>
                  <a
                    class="contact__button-chat"
                    href="viber://pa?chatURI=lpofficial"
                  >
                    <img
                      src="~~/assets/icons/contactsManagerViber.svg"
                      alt=""
                    />
                    <span>{{ _T("@viber chat") }}</span>
                  </a>
                  <a
                    class="contact__button-chat"
                    href="https://t.me/LogicPowerBot"
                  >
                    <img
                      src="~~/assets/icons/contactsManagerTelegram.svg"
                      alt=""
                    />
                    <span>{{ _T("@Telegram chat") }}</span>
                  </a>
                </div>
                <p class="contact__block-text">
                  ({{ _T("@Calls within Ukraine are free") }})
                </p>
              </div>
              <div class="contact__block-social">
                <div class="contact__block-subtitle">
                  {{ _T("@We always happy to answer questions") }}
                </div>
                <div class="contact__block-social-w">
                  <a
                    v-for="social in socials"
                    class="contact__block-social-link"
                    :href="social.link"
                    target="_blank"
                  >
                    <img :src="social.iconBlack" :alt="social.alt" />
                  </a>
                </div>
              </div>
            </div>
            <div data-section="sales" class="contact__main-block">
              <div class="contact__block-title-w">
                <h3 class="contact__block-title">
                  <span
                    id="sales"
                    class="ui-anchor"
                    :style="{ '--topScroll': `-${heightHeader}` }"
                  />
                  {{ _T("@Call-center") }}
                </h3>
                <div class="contact__block-line" />
              </div>
              <div class="contact__block-employee-list">
                <EmployeeCard
                  v-for="(manager, index) of retailManagerList"
                  :key="index"
                  class="contact__employee-item"
                  :manager="manager"
                />
              </div>
            </div>
            <div data-section="techSupport" class="contact__main-block">
              <div class="contact__block-title-w">
                <h3 class="contact__block-title">
                  <span
                    id="techSupport"
                    class="ui-anchor"
                    :style="{ '--topScroll': `-${heightHeader}` }"
                  />
                  {{ _T("@Technical support") }}
                </h3>
                <div class="contact__block-line" />
              </div>
              <div class="contact__block-description">
                <p class="contact__block-info-text">
                  {{ _T("@All products covered by warranty") }}
                </p>
                <p class="contact__block-info-text">
                  {{ _T("@Warranty period indicated in warranty card") }}
                </p>
              </div>
              <div class="contact__block-employee-list">
                <div
                  v-for="manager of techSupportList"
                  class="contact__tech-support"
                >
                  <EmployeeCard
                    class="contact__tech-support-item"
                    :manager="manager"
                  />

                  <a
                    class="contact__button-transparent"
                    :href="`tel:${manager.phone}`"
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        class="contact__btn-img"
                        d="M18.1183 14.702L14.0001 15.5C11.2184 14.1038 9.50009 12.5 8.50009 10L9.27004 5.8699L7.81461 2L4.06369 2C2.93614 2 2.04823 2.93178 2.21663 4.04668C2.63704 6.83 3.87662 11.8765 7.50009 15.5C11.3053 19.3052 16.7858 20.9564 19.8021 21.6127C20.9669 21.8662 22.0001 20.9575 22.0001 19.7655L22.0001 16.1812L18.1183 14.702Z"
                        stroke="#F36C21"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span>{{ _T("@Call") }}</span>
                  </a>
                </div>
              </div>
            </div>
            <div data-section="service" class="contact__main-block">
              <Service />
            </div>
            <div id="shops" data-section="shops" class="contact__main-block">
              <div class="contact__block-title-w">
                <h3 class="contact__block-title">
                  <span
                    class="ui-anchor"
                    :style="{ '--topScroll': `-${heightHeader}` }"
                  />
                  {{ _T("@Shops") }}
                </h3>
                <div class="contact__block-line" />
              </div>
              <div class="contact__block-description">
                <h4 class="contact__block-subtitle">
                  {{ _T("@Kolomyia") }}
                </h4>
                <p class="contact__block-info-text">
                  {{ _T("@Address") }}:
                  {{
                    _T("@store address in Kolomyiastore address in Kolomyia")
                  }}
                </p>
                <p class="contact__block-info-text">
                  {{ _T("@Schedule Kolomyia") }}
                </p>
                <a
                  :href="`tel:${_T('@Phone market Kolomyia')}`"
                  class="contact__block-info-text call"
                  >{{ _T("@Telephone") }}: {{ _T("@Phone market Kolomyia") }}
                </a>
              </div>

              <div class="contact__block-map-w">
                <iframe
                  class="contact__block-map"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1321.0924483482515!2d25.021894781545264!3d48.52968822726798!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4736d32da7d131bd%3A0xf9316d4fa3608d44!2zKExQKSBMb2dpY1Bvd2VyIC0g0JDQutGD0LzRg9C70Y_RgtC-0YDQuCDRgtCwINGA0LXQt9C10YDQstC90LUg0LbQuNCy0LvQtdC90L3Rjw!5e0!3m2!1suk!2sua!4v1700576970658!5m2!1suk!2sua"
                  style="border: 0"
                  loading="lazy"
                  aria-hidden="false"
                  tabindex="0"
                  referrerpolicy="no-referrer-when-downgrade"
                />
              </div>
              <div class="contact__block-line" />

              <div class="contact__block-description">
                <h4 class="contact__block-subtitle">
                  {{ _T("@Odesa") }}
                </h4>
                <p class="contact__block-info-text">
                  {{ _T("@Address") }}: {{ _T("@Industrial market 7 km") }}
                </p>
                <p class="contact__block-info-text">
                  {{ _T("@Schedule 7km") }}
                </p>
                <a
                  :href="`tel:${_T('@Phone market 7 km')}`"
                  class="contact__block-info-text call"
                  >{{ _T("@Telephone") }}: {{ _T("@Phone market 7 km") }}
                </a>
              </div>

              <div class="contact__block-map-w">
                <iframe
                  class="contact__block-map"
                  loading="lazy"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10996.652086968357!2d30.6352593!3d46.4454668!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x65fa4f41baab6944!2sLogicPower!5e0!3m2!1sru!2sua!4v1592986552060!5m2!1sru!2sua"
                  style="border: 0"
                  aria-hidden="false"
                  tabindex="0"
                />
              </div>
              <div class="contact__block-line" />
              <div class="contact__block-description">
                <h4 class="contact__block-subtitle">
                  {{ _T("@Odesa") }}
                </h4>
                <p class="contact__block-info-text">
                  {{ _T("@Address") }}: {{ _T("@Prom.rynok Starokonnyy") }}
                </p>
                <p class="contact__block-info-text">
                  {{ _T("@Schedule Starokonnyy") }}
                </p>
                <a
                  :href="`tel:${_T('@Phone Market Starokonny')}`"
                  class="contact__block-info-text call"
                  >{{ _T("@Telephone") }}: {{ _T("@Phone Market Starokonny") }}
                </a>
              </div>
              <div class="contact__block-map-w">
                <iframe
                  class="contact__block-map"
                  loading="lazy"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2747.4966733400734!2d30.7112497!3d46.4784769!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x510ed329a1dace3d!2sLogicPower!5e0!3m2!1sru!2sua!4v1592986700273!5m2!1sru!2sua"
                  style="border: 0"
                  aria-hidden="false"
                  tabindex="0"
                />
              </div>
              <div class="contact__block-line" />
              <div class="contact__block-description">
                <h4 class="contact__block-subtitle">
                  {{ _T("@Odesa") }}
                </h4>
                <p class="contact__block-info-text">
                  {{ _T("@Address") }}: {{ _T("@Nebesnoi Sotny avenue") }}
                </p>
                <p class="contact__block-info-text">
                  {{ _T("@Schedule Selyanka") }}
                </p>
                <a
                  :href="`tel:${_T('@Phone market Selyanka')}`"
                  class="contact__block-info-text call"
                  >{{ _T("@Telephone") }}: {{ _T("@Phone market Selyanka") }}
                </a>
              </div>
              <div class="contact__block-map-w">
                <iframe
                  class="contact__block-map"
                  loading="lazy"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d343.88882708408215!2d30.710111198252406!3d46.40686231749278!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40c633b0678e4b13%3A0x8c6f39b843a3b43a!2sLogicPower!5e0!3m2!1sru!2sua!4v1632305240162!5m2!1sru!2sua"
                  style="border: 0"
                  aria-hidden="false"
                  tabindex="0"
                />
              </div>
            </div>
            <div data-section="salesOpt" class="contact__main-block">
              <div class="contact__block-title-w">
                <h3 class="contact__block-title">
                  <span
                    id="salesOpt"
                    class="ui-anchor"
                    :style="{ '--topScroll': `-${heightHeader}` }"
                  />
                  {{ _T("@Wholesale Department") }}
                </h3>
                <div class="contact__block-line" />
              </div>
              <div class="contact__block-employee-list">
                <EmployeeCard
                  v-for="(manager, index) of wholeSaleManagers"
                  :key="index"
                  class="contact__employee-item"
                  :manager="manager"
                />
              </div>
            </div>
            <div data-section="accounting" class="contact__main-block">
              <div class="contact__block-title-w">
                <h3 class="contact__block-title">
                  <span
                    id="accounting"
                    class="ui-anchor"
                    :style="{ '--topScroll': `-${heightHeader}` }"
                  />
                  {{ _T("@Accounting department") }}
                </h3>
                <div class="contact__block-line" />
              </div>
              <p class="contact__block-text">
                {{ _T("@For all questions documentation") }}
              </p>
              <div class="contact__block-employee-list">
                <EmployeeCard
                  v-for="(manager, index) of accountantList"
                  :key="index"
                  class="contact__tech-support-item"
                  :manager="manager"
                />
              </div>
            </div>
            <!--            <div data-section="legal" class="contact__main-block">-->
            <!--              <div class="contact__block-title-w">-->
            <!--                <h3 class="contact__block-title">-->
            <!--                  <span-->
            <!--                    id="legal"-->
            <!--                    class="ui-anchor"-->
            <!--                    :style="{ '&#45;&#45;topScroll': `-${heightHeader}` }"-->
            <!--                  />-->
            <!--                  {{ _T("@Legal address and contacts") }}-->
            <!--                </h3>-->
            <!--                <div class="contact__block-line" />-->
            <!--              </div>-->
            <!--              <div class="contact__block-content">-->
            <!--                <p class="contact__block-info-text">-->
            <!--                  {{ _T("@Legal contact") }}-->
            <!--                </p>-->
            <!--                <h4 class="contact__block-subtitle">-->
            <!--                  {{ _T("@Legal address") }}:-->
            <!--                </h4>-->
            <!--                <p class="contact__block-info-text">-->
            <!--                  {{ _T("@Mala Arnautska 105/1") }}-->
            <!--                </p>-->
            <!--                <div class="contact__block-info-buttons">-->
            <!--                  <a-->
            <!--                    class="contact__button-transparent"-->
            <!--                    href="mailto:info@logicpower.ua"-->
            <!--                  >-->
            <!--                    <svg-->
            <!--                      width="25"-->
            <!--                      height="24"-->
            <!--                      viewBox="0 0 25 24"-->
            <!--                      fill="none"-->
            <!--                      xmlns="http://www.w3.org/2000/svg"-->
            <!--                    >-->
            <!--                      <path-->
            <!--                        class="contact__btn-img"-->
            <!--                        d="M7.5 9L12.5 12.5L17.5 9"-->
            <!--                        stroke="#F36C21"-->
            <!--                        stroke-width="1.5"-->
            <!--                        stroke-linecap="round"-->
            <!--                        stroke-linejoin="round"-->
            <!--                      />-->
            <!--                      <path-->
            <!--                        class="contact__btn-img"-->
            <!--                        d="M2.5 17V7C2.5 5.89543 3.39543 5 4.5 5H20.5C21.6046 5 22.5 5.89543 22.5 7V17C22.5 18.1046 21.6046 19 20.5 19H4.5C3.39543 19 2.5 18.1046 2.5 17Z"-->
            <!--                        stroke="#F36C21"-->
            <!--                        stroke-width="1.5"-->
            <!--                      />-->
            <!--                    </svg>-->
            <!--                    <span>E-mail: {{ "info@logicpower.ua" }}</span>-->
            <!--                  </a>-->
            <!--                  <a class="contact__button-transparent" href="tel:0800309988">-->
            <!--                    <svg-->
            <!--                      width="24"-->
            <!--                      height="24"-->
            <!--                      viewBox="0 0 24 24"-->
            <!--                      fill="none"-->
            <!--                      xmlns="http://www.w3.org/2000/svg"-->
            <!--                    >-->
            <!--                      <path-->
            <!--                        class="contact__btn-img"-->
            <!--                        d="M18.1183 14.702L14.0001 15.5C11.2184 14.1038 9.50009 12.5 8.50009 10L9.27004 5.8699L7.81461 2L4.06369 2C2.93614 2 2.04823 2.93178 2.21663 4.04668C2.63704 6.83 3.87662 11.8765 7.50009 15.5C11.3053 19.3052 16.7858 20.9564 19.8021 21.6127C20.9669 21.8662 22.0001 20.9575 22.0001 19.7655L22.0001 16.1812L18.1183 14.702Z"-->
            <!--                        stroke="#F36C21"-->
            <!--                        stroke-width="1.5"-->
            <!--                        stroke-linecap="round"-->
            <!--                        stroke-linejoin="round"-->
            <!--                      />-->
            <!--                    </svg>-->
            <!--                    <span>{{ _T("@Telephone") }}: 0800 309 988</span>-->
            <!--                  </a>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->

            <div data-section="tenderDepartment" class="contact__main-block">
              <div class="contact__block-title-w">
                <h3 class="contact__block-title">
                  <span
                    id="tenderDepartment"
                    class="ui-anchor"
                    :style="{ '--topScroll': `-${heightHeader}` }"
                  />
                  {{ _T("@Tender department") }}
                </h3>
                <div class="contact__block-line" />
              </div>
              <div class="contact__block-employee-list">
                <EmployeeCard
                  v-for="(manager, index) of tenderDepartment"
                  :key="index"
                  class="contact__employee-item"
                  :manager="manager"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import EmployeeCard from "~~/modules/shared/infoCard/EmployeeCard.vue";
import { useHeaderStore } from "~~/store/headerStore";
import socials from "~/config/social.config";
import { addScopedEventListener } from "~~/utils/eventListener";
import Service from "~/modules/static/warranty/components/Service.vue";

const heightHeaderStore = useHeaderStore().getHeightHeader;

const navList = ref(null);
const heightHeader = ref("");
const isActiveNav = ref(0);

const sections = ref(null);
const scrollTopMargin = 20;

const navigation = [
  { link: "generalPhone", title: "@General number" },
  { link: "sales", title: "@Sales department" },
  { link: "techSupport", title: "@Technical support" },
  { link: "service", title: "@Service" },
  { link: "shops", title: "@Shops" },
  { link: "salesOpt", title: "@Wholesale Department" },
  { link: "accounting", title: "@Accounting department" },
  // { link: "legal", title: "@Legal address and contacts" },
  { link: "tenderDepartment", title: "@Tender department" },
];

const retailManagerList = [
  // {
  //   position: _T("@Head of retail department"),
  //   name: _T("@Name head of retail department"),
  //   photo: "https://logicfox.info/foto/LogicPower/contacts/georgieva-anna.png",
  //   phone: _T("@Tel num head of retail"),
  //   viber: "viber://pa?chatURI=lpofficial",
  //   telegram: "https://t.me/LogicPowerBot",
  //   email: "",
  // },
  // {
  //   position: _T('@Retail Sales Manager'),
  //   name: _T('@Retail manager 1'),
  //   photo: 'https://logicfox.info/foto/LogicPower/contacts/georgieva-anna.png',
  //   phone: _T('@Retail manager tel 1'),
  //   email: _T('@Retail manager email 1')
  // },
  {
    position: _T("@Retail Sales Manager"),
    name: _T("@Retail manager 2"),
    photo:
      "https://logicfox.info/foto/LogicPower/contacts/burakova-aleksandra.png",
    phone: _T("@Retail manager tel 2"),
    viber: "viber://pa?chatURI=lpofficial",
    telegram: "https://t.me/LogicPowerBot",
    email: _T("@Retail manager email 2"),
  },
  {
    position: _T("@Retail Sales Manager"),
    name: _T("@Retail manager 3"),
    photo:
      "https://logicfox.info/foto/LogicPower/contacts/lotockiy-vyacheslav.png",
    phone: _T("@Retail manager tel 3"),
    viber: "viber://pa?chatURI=lpofficial",
    telegram: "https://t.me/LogicPowerBot",
    email: _T("@Retail manager email 3"),
  },
  // {
  //   position: _T("@Retail Sales Manager"),
  //   name: _T("@Retail manager 4"),
  //   photo: "https://logicfox.info/foto/LogicPower/contacts/bilokur-vladislav.png",
  //   phone: _T("@Retail manager tel 4"),
  //   email: _T("@Retail manager email 4"),
  // },
  {
    position: _T("@Retail Sales Manager"),
    name: _T("@Retail manager 5"),
    photo:
      "https://logicfox.info/foto/LogicPower/contacts/tokarev-aleksandr.png",
    phone: _T("@Retail manager tel 5"),
    viber: "viber://pa?chatURI=lpofficial",
    telegram: "https://t.me/LogicPowerBot",
    email: _T("@Retail manager email 5"),
  },
];

const wholeSaleManagers = [
  {
    position: _T("@Wholesale Manager"),
    name: _T("@Wholesale manager 1"),
    photo:
      "https://logicfox.info/foto/LogicPower/contacts/kremenyuk-oleg-opt.png",
    phone: _T("@Wholesale manager tel 1"),
    viber: _T("@Wholesale manager tel 1"),
    telegram: _T("@Wholesale manager tel 1"),
    email: _T("@Wholesale manager email 1"),
  },
  {
    position: _T("@Wholesale Manager"),
    name: _T("@Wholesale manager 2"),
    photo:
      "https://logicfox.info/foto/LogicPower/contacts/kremenyuk-igor-opt.png",
    phone: _T("@Wholesale manager tel 2"),
    viber: _T("@Wholesale manager tel 2"),
    telegram: _T("@Wholesale manager tel 2"),
    email: _T("@Wholesale manager email 2"),
  },
  // {
  //   position: _T('@Wholesale Manager'),
  //   name: _T('@Wholesale manager 3'),
  //   photo: 'https://logicfox.info/foto/LogicPower/contacts/lotockiy-vyacheslav.png',
  //   phone: _T('@Wholesale manager tel 3'),
  //   email: _T('@Wholesale manager email 3')
  // },
  // {
  //   position: _T("@Wholesale Manager"),
  //   name: _T("@Wholesale manager 4"),
  //   photo:
  //     "https://logicfox.info/foto/LogicPower/contacts/lozickaya-valeria-opt.png",
  //   phone: _T("@Wholesale manager tel 4"),
  //   viber: _T("@Wholesale manager tel 4"),
  //   telegram: _T("@Wholesale manager tel 4"),
  //   email: _T("@Wholesale manager email 4"),
  // },
  // {
  //   position: _T('@Wholesale Manager'),
  //   name: _T('@Wholesale manager 5'),
  //   photo: 'https://logicfox.info/foto/LogicPower/contacts/cibriy-max-opt.png',
  //   phone: _T('@Wholesale manager tel 5'),
  //   email: _T('@Wholesale manager email 5')
  // },
  // {
  //   position: _T('@Wholesale Manager'),
  //   name: _T('@Wholesale manager 6'),
  //   photo: 'https://logicfox.info/foto/LogicPower/contacts/bilokur-vladislav.png',
  //   phone: _T('@Wholesale manager tel 6'),
  //   email: _T('@Wholesale manager email 6')
  // },
  {
    position: _T("@Wholesale Manager"),
    name: _T("@Wholesale manager 7"),
    photo:
      "https://logicfox.info/foto/LogicPower/contacts/hakimova-karina-opt.png",
    phone: _T("@Wholesale manager tel 7"),
    viber: _T("@Wholesale manager tel 7"),
    telegram: _T("@Wholesale manager tel 7"),
    email: _T("@Wholesale manager email 7"),
  },
  // {
  //   position: _T('@Wholesale Manager'),
  //   name: _T('@Wholesale manager 8'),
  //   photo: 'https://logicfox.info/foto/video/Yuryak-Roman.jpg',
  //   phone: _T('@Wholesale manager tel 8'),
  //   viber: _T('@Wholesale manager tel 8'),
  //   telegram: _T('@Wholesale manager tel 8'),
  //   email: _T('@Wholesale manager email 8')
  // },
];

const tenderDepartment = [
  {
    position: _T("@Head of tender department"),
    name: _T("@Head of tender department Name"),
    photo: "https://logicfox.info/foto/LogicPower/contacts/o-potseluev.png",
    phone: _T("@Head of tender department tel.num"),
    viber: _T("@Head of tender department tel.num"),
    telegram: _T("@Head of tender department tel.num"),
    email: _T("@Head of tender department email"),
  },
];

const techSupportList = [
  {
    position: _T("@Technical Specialist"),
    name: _T("@Technical Specialist Name"),
    photo:
      "https://logicfox.info/foto/LogicPower/contacts/berezinskiy-anton-support.png",
    phone: _T("@Technical Specialist tel.num"),
    viber: _T("@Technical Specialist viber.num"),
    telegram: _T("@Technical Specialist telegram.num"),
    email: _T("@Technical Specialist email"),
  },
  {
    position: _T("@Technical Specialist"),
    name: _T("@Technical Specialist 2 Name"),
    photo: "https://logicfox.info/foto/LogicPower/contacts/CherevykSergey.png",
    phone: _T("@Technical Specialist 2 tel.num"),
    viber: _T("@Technical Specialist 2 viber.num"),
    telegram: _T("@Technical Specialist 2 telegram.num"),
    email: _T("@Technical Specialist 2 email"),
  },
];

const accountantList = [
  {
    position: _T("@Accountant"),
    name: _T("@Accountant Name"),
    photo:
      "https://logicfox.info/foto/LogicPower/contacts/lrina-kasper-accounten.png",
    phone: _T("@Accountant tel.num"),
    viber: _T("@Accountant tel.num"),
    telegram: _T("@Accountant tel.num"),
    email: _T("@Accountant email"),
  },
];

function getHeaderHeight() {
  heightHeader.value =
    parseInt(heightHeaderStore.additionalInfo) +
    parseInt(heightHeaderStore.header) +
    "px";
}

function activeSection() {
  for (const key in sections.value.children) {
    if (Object.hasOwnProperty.call(sections.value.children, key)) {
      const el = sections.value.children[key];
      if (
        window.pageYOffset >=
        el.offsetTop -
          (parseInt(heightHeaderStore.additionalInfo) +
            parseInt(heightHeaderStore.header))
      ) {
        for (const key in navList.value.children) {
          if (Object.hasOwnProperty.call(navList.value.children, key)) {
            const elNav = navList.value.children[key];
            elNav.classList.remove("active");

            if (elNav.dataset.section === el.dataset.section) {
              elNav.classList.add("active");
            }
          }
        }
      }
    }
  }
}

function scrollingTo(index) {
  window.scrollTo(
    0,
    sections.value.children[index].offsetTop -
      (parseInt(heightHeaderStore.additionalInfo) +
        parseInt(heightHeaderStore.header)) +
      scrollTopMargin,
  );
}

onMounted(() => {
  getHeaderHeight();
  activeSection();

  addScopedEventListener(window, "resize", activeSection);
  addScopedEventListener(window, "scroll", activeSection);
  addScopedEventListener(window, "resize", getHeaderHeight);
});
</script>

<style lang="scss" scoped>
.ui-anchor {
  --topScroll: 0;
  scroll-margin-top: var(--topScroll);
}

.contact {
  @include flex-container(column, center, center);

  @extend %padding-wrp;

  &_block-info-text {
    @include font(18, 24);
    letter-spacing: 0.02em;

    @include mobile {
      @include font;
    }
  }

  &__w {
    @extend %width-main;

    @include flex-container;
    gap: 24px;

    padding-bottom: 64px;
  }

  &__nav {
    --circ-r: 24px;

    position: relative;

    @include bigMobile {
      display: none;
    }
  }

  &__nav-line {
    position: absolute;
    left: var(--circ-r);
    transform: translateX(-50%);

    height: 100%;
    width: 8px;

    border-radius: 6px;

    background-color: white;
    z-index: -1;
  }

  &__nav-list {
    width: 100%;
    max-width: 230px;

    position: sticky;
    top: calc(16px + v-bind(heightHeader));

    @include flex-container(column, null, null);
    gap: 32px;

    padding: 16px 0;
  }

  &__nav-list-item {
    @include flex-container(row, flex-start, center);
    gap: 16px;

    cursor: pointer;

    &:hover {
      .contact__nav-list-count {
        border-color: var(--color-primary-base);
        background-color: #fef0e9;
      }

      .contact__nav-list-title {
        color: #2b2b2b;
      }
    }

    &.active {
      .contact__nav-list-count {
        border-color: var(--color-primary-base);
        background-color: var(--color-primary-base);
        color: white;
      }

      .contact__nav-list-title {
        color: #2b2b2b;
      }
    }
  }

  &__title {
    @include font(36, 43, 700);
    color: #2b2b2b;
  }

  &__nav-list-count {
    min-width: calc(var(--circ-r) * 2);
    height: calc(var(--circ-r) * 2);

    @include flex-container(row, center, center);

    @include font(18, 24);
    text-align: center;
    color: var(--color-primary-base);

    border-radius: 50%;
    border: 1px solid white;
    background-color: white;

    transition: background-color 0.1s ease-in-out;
  }

  &__nav-list-title {
    @include font(20, 28);
    letter-spacing: 0.02em;
    color: #8a8a8a;
  }

  &__main {
    @include flex-container(column, null, null);
    gap: 36px;

    padding-top: 16px;

    @include mobile {
      gap: 24px;
    }
  }

  &__blocks-wrp {
    @include flex-container(column, null, null);
    gap: 36px;

    padding-top: 16px;

    @include mobile {
      gap: 24px;
    }
  }

  &__main-block {
    --local-pad: 32px;

    @include flex-container(column, null, null);
    gap: 16px;

    background: white;
    box-shadow: 0 0 24px rgba(0, 0, 0, 0.1);
    border-radius: 8px;

    padding: var(--local-pad);

    @include mobile {
      gap: 16px;

      padding: 16px;
    }
  }

  &__block-title-w {
    @include flex-container(column, null, null);
    gap: 16px;
  }

  &__block-title {
    @include font(20, 30, 600);
    text-transform: uppercase;
    color: #2b2b2b;

    @include mobile {
      @include font(20, 30, 600);
    }
  }

  &__block-line {
    width: 100%;
    height: 1px;

    background-color: var(--color-primary-base);
  }

  &__block-content {
    @include flex-container(column, null, null);
    gap: 16px;

    @include mobile {
      align-items: center;
      margin-bottom: 24px;
    }
  }

  &__block-content-wrp-tel {
    @include flex-container(null, flex-start, center);
    flex-wrap: wrap;

    gap: 16px;
    font-size: 18px;
    line-height: 24px;
    font-weight: 400;
    letter-spacing: 0.02em;
    color: var(--color-primary-base);
    transition: color 0.2s ease;
  }

  &__block-subtitle {
    @include font(16, 22);
    letter-spacing: 0.02em;

    @include mobile {
      @include font(16, 22);
      text-align: center;
      text-transform: none;
    }
  }

  &__button-transparent {
    max-width: max-content;
    width: 100%;

    @include flex-container(row, flex-start, center);
    gap: 16px;

    border: 1px solid var(--color-primary-base);
    border-radius: 8px;

    padding: 8px 32px;

    transition:
      background-color 0.2s,
      border-color 0.2s;

    &:hover {
      border-color: #ff5b00;
      background-color: #ff5b00;

      & span {
        color: white;
      }

      .contact__btn-img {
        stroke: white;
      }
    }

    &:active {
      border-color: #ac450b;
      background-color: #ac450b;

      & span {
        color: white;
      }

      .contact__btn-img {
        stroke: white;
      }
    }

    & span {
      @include font(18, 24);
      letter-spacing: 0.02em;

      color: var(--color-primary-base);

      transition: color 0.2s ease;
    }
  }

  &__button-chat {
    max-width: 234px;
    width: 100%;

    @include flex-container(row, flex-start, center);
    gap: 16px;

    border: 1px solid var(--color-primary-base);
    border-radius: 8px;

    padding: 8px 32px;

    transition:
      background-color 0.2s,
      border-color 0.2s;

    &:hover {
      border-color: #ff5b00;
      background-color: #ff5b00;

      & span {
        color: white;
      }

      .contact__btn-img {
        stroke: white;
      }
    }
  }

  &__block-text {
    @include font;
    letter-spacing: 0.02em;

    @include mobile {
      @include font(12, 16);
      text-align: center;
    }
  }

  &__block-social {
    @include flex-container(column, center, flex-start);
    gap: 16px;

    @include mobile {
      align-items: center;
    }
  }

  &__block-social-w {
    @include flex-container(row, flex-start, center);
    gap: 16px;

    @include mobile {
      justify-content: center;
    }
  }

  &__block-social-link {
    cursor: pointer;

    & img {
      @include fixedHW(32px);
    }
  }

  &__block-employee-list {
    @include flex-container(row, flex-start);
    flex-wrap: wrap;
    gap: 16px;
  }

  &__employee-item {
    --gap: 16px;

    @include set-item-count-in-row(3);

    @include smallestScreen {
      @include set-item-count-in-row(2);
    }

    @include mobile {
      @include set-item-count-in-row(1);
    }
  }

  &__tech-support {
    @include flex-container(column, space-between, flex-start);
    gap: 16px;
  }

  &__tech-support-item {
    max-width: 400px;
    width: 100%;
  }

  &__block-description {
    @include flex-container(column, null, null);
    gap: 16px;

    & .contact__block-subtitle {
      text-align: left;
    }
  }

  &__block-map-w {
    @include flex-container(row, center, center);

    width: 100%;
    max-height: 100%;
    overflow: hidden;
  }

  &__block-map {
    width: 100%;
    height: 523px;
  }

  &__block-info-text {
    @include font(16, 22);
    letter-spacing: 0.02em;

    &.call {
      &:hover {
        color: var(--color-primary-base);
      }
    }

    @include mobile {
      @include font;
    }
  }

  &__block-info-buttons {
    max-width: 360px;
    width: 100%;

    @include flex-container(column, flex-start);

    gap: 16px;

    & > a {
      width: 100%;
    }
  }

  &__block-legal-contacts {
    max-width: 415px;
    width: 100%;

    @include flex-container(row, flex-start, center);
    gap: 16px;

    border: 1px solid #8a8a8a;
    border-radius: 8px;

    padding: 8px 12px;

    transition: border-color 0.2s ease;

    &:hover {
      border-color: var(--color-primary-dark);

      & span {
        color: var(--color-primary-dark);
      }
    }

    & span {
      @include font(20, 28);
      letter-spacing: 0.02em;

      transition: color 0.2s ease;

      @include mobile {
        @include font;
      }
    }
  }
}
</style>
